import React from "react";

export default function Input(props) {
	return (
		<input className="border-2 pl-2 py-1 text-right" type={props.type ?? "text"} defaultValue={props.defaultValue} {...props} />
	)
}